import { z } from 'zod';

export const INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY = 'investmentsQuotesDetailed';
export const INVESTMENTS_QUOTES_DETAILED_VERSION_NUMBER = 1;
// export type INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY = typeof INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY;

export const QuotesSecurityTypeSchema = z.enum(['STOCK', 'CRYPTOCURRENCY', 'CURRENCY']);
export type QuotesSecurityType = z.infer<typeof QuotesSecurityTypeSchema>;

export const SymbolInputSchema = z.object({
  clientId: z.string().optional(),
  symbol: z.string(),
  securityType: QuotesSecurityTypeSchema.optional(),
  currency: z.string().optional(),
});
export type SymbolInput = z.infer<typeof SymbolInputSchema>;

export const GetDetailedQuotesRequestSchema = z.object({
  clientId: z.string().optional(),
  symbols: z.array(SymbolInputSchema),
  params: z
    .object({
      realTime: z.boolean().optional(),
      includeFallback: z.boolean().optional(),
    })
    .optional(),
});
export type GetDetailedQuotesRequest = z.infer<typeof GetDetailedQuotesRequestSchema>;

// some fields might be missed for particular symbols - if required is missed quote disqualifies with assertion error
export const DetailedQuoteSchema = z.object({
  clientId: z.string().optional(),
  name: z.string().optional(),
  symbol: z.string(),
  lastPrice: z.number(),
  quoteTime: z.string().datetime({ offset: true }),
  amtChange: z.number().optional(),
  pctChange: z.number().optional(),
  volume: z.number().optional(),
  openPrice: z.number().optional(),
  yearHigh: z.number().optional(),
  yearLow: z.number().optional(),
  fiftyTwoWeekHigh: z.number().optional(),
  fiftyTwoWeekHighDate: z.string().date().optional(),
  fiftyTwoWeekLow: z.number().optional(),
  fiftyTwoWeekLowDate: z.string().date().optional(),
  previousClosePrice: z.number().optional(),
  dayHigh: z.number().optional(),
  dayLow: z.number().optional(),
  closePrice: z.number().optional(),
  mktCap: z.number().optional(),
  peRatio: z.number().optional(),
  divYield: z.number().optional(),
  realTime: z.boolean().optional(),
  relatedSymbol: z.string().optional(),
  mode: z.string().optional(), // 'r'?
  securityType: QuotesSecurityTypeSchema,
  currency: z.string().optional(),
});
export type DetailedQuote = z.infer<typeof DetailedQuoteSchema>;

export const QuotesMetaDataSchema = z.object({
  pageSize: z.number(),
  limit: z.number(),
  asOf: z.string(),
  currentPage: z.number(),
  offset: z.number(),
  totalPages: z.number(),
  totalSize: z.number(),
});
export type QuotesMetaData = z.infer<typeof QuotesMetaDataSchema>;

export const GetDetailedQuotesErrorSchema = z
  .object({
    title: z.string(),
    httpStatus: z.number(),
    code: z.string(),
    extData: SymbolInputSchema.partial().passthrough().optional(),
  })
  .passthrough();
export type GetDetailedQuotesError = z.infer<typeof GetDetailedQuotesErrorSchema>;

export type InvestmentsQuotesDetailedStoreState = {
  entities: Record<string, DetailedQuote>; // keyed by securityType:symbol:currency e.g. STOCK:AAPL:USD
  ids: string[];
  loadPending: boolean;
  isLoading?: boolean;
  error?: string | Error | null;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY]: InvestmentsQuotesDetailedStoreState;
  }
}
